import classNames from 'classnames';
import React from 'react';
import styles from './tag.scss';

import { Tag as WixTag } from '@wix/design-system';

interface Props {
  id: string;
  children: React.ReactNode;
  disabled?: boolean;
  removable: boolean;
}

const Tag = ({ children, ...props }: Props) => {
  return (
    <span className={classNames(styles.tag)}>
      <WixTag {...props}>{children}</WixTag>
    </span>
  );
};

export default Tag;
